import { Cookies } from '@/scripts/libs/cookies'
import {
  STICKY_BAR_TOOLTIP_CLOSED,
  STICKY_BAR_CONTENT_TOOLTIP_IS_IN_PAGE,
} from '@/scripts/constants/cookies'

class StickyBarTooltip {
  isClosed = () => {
    return Cookies.get(STICKY_BAR_TOOLTIP_CLOSED) === 'true'
  }

  isEnabled = () => {
    return Cookies.get(STICKY_BAR_CONTENT_TOOLTIP_IS_IN_PAGE) === 'true'
  }

  isHidden = () => {
    if (!this.isEnabled()) {
      return true
    }
    return this.isClosed()
  }

  setClosedCookieToTrue() {
    Cookies.set(STICKY_BAR_TOOLTIP_CLOSED, true)
  }

  setClosedCookieToFalse() {
    Cookies.set(STICKY_BAR_TOOLTIP_CLOSED, false)
  }

  setContentCookieToTrue() {
    Cookies.set(STICKY_BAR_CONTENT_TOOLTIP_IS_IN_PAGE, true)
  }

  setContentCookieToFalse() {
    Cookies.set(STICKY_BAR_CONTENT_TOOLTIP_IS_IN_PAGE, false)
  }
}

export default new StickyBarTooltip()
